import { memo, useCallback } from 'react';

import { CheckIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';
import { Modal, ModalCloseButton } from '@air/primitive-modal';
import { useAirModal } from '@air/provider-modal';

import { DemoFormModal } from '~/components/Modals/DemoFormModal';

export const enterpriseOptions = [
  'Custom storage & user limits',
  '180 day deletion recovery',
  'Custom roles & permissions',
  'SAML-based SSO',
  'Reporting, analytics, API Access & Custom Integrations',
  'Dedicated onboarding, support Slack, and CSM',
];

export const EnterprisePlanModal = memo(({ onClose }: AirModalProps<object>) => {
  const [showDemoFormModal] = useAirModal(DemoFormModal);

  const handleOpenDemoForm = useCallback(() => {
    showDemoFormModal();
    onClose();
  }, [onClose, showDemoFormModal]);

  return (
    <Modal isOpen className="w-[320px]" onDismiss={onClose}>
      <div className="flex items-center justify-end">
        <ModalCloseButton className="shrink-0" onClick={onClose} />
      </div>
      <div className="flex flex-col items-center gap-4">
        <p className="text-center font-semibold ads:text-primary text-24 text-gray-12"> Enterprise plan</p>
        <p className="text-center ads:text-secondary text-12 text-gray-11">
          For medium to large teams with 20+ members
        </p>
        <p className="text-center font-medium ads:text-primary text-16 text-gray-12">Need to make changes?</p>
        <Button appearance="outline" color="blue" onClick={handleOpenDemoForm} size="large" type="button">
          Contact Us
        </Button>
      </div>
      <div className="my-10 flex flex-col gap-3">
        <p className="font-semibold ads:text-primary text-16 text-gray-12">Your plan includes</p>
        <div className="flex flex-col gap-3">
          {enterpriseOptions.map((option, index) => (
            <div className="flex gap-2" key={index}>
              <CheckIcon className="ads:text-icon-success text-teal-9" size="sm" />
              <p className="ads:text-secondary text-14 text-gray-11">{option}</p>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
});

EnterprisePlanModal.displayName = 'EnterprisePlanModal';
